import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { sortBy } from 'lodash';
import Tooltip from '../Tooltip';
import Label from '../Label';
import HotjarMasked from '../HotjarMasked';
import { getDaysBetweenDates, getFromNowDate, MIN_DAYS_TO_SHOW_APPLIANCE_STATUS_WARNING } from '../../utils/dateUtility';

const WarningIcon = () => (
  <span className="custom-icon custom-icon-circle custom-icon-small custom-icon-warning">
    !
  </span>
);

// eslint-disable-next-line react/no-multi-comp
const ApplianceStatus = ({ records, dueDate }) => (
  <div>
    {records && records.length > 0 ? (
      <table className="table table-striped table-fixed">
        <thead>
          <tr>
            <th>
              <strong>Instance</strong>
            </th>
            <th>
              <strong>Environment</strong>
            </th>
            <th>
              <strong>Last Usage Data Received</strong>
            </th>
          </tr>
        </thead>
        <tbody>
          {sortBy(records, item => {
            const rank = {
              Production: 1,
              Staging: 2,
              Development: 3
            };
            return rank[item.environment];
          }).map(
            ({
              environment,
              root_domain_auth: rootDomainAuth,
              last_submitted: lastSubmitted
            }) => (
              <tr key={rootDomainAuth}>
                <td>
                  <HotjarMasked isInline>{rootDomainAuth}</HotjarMasked>
                </td>
                <td>
                  <Label
                    style={{ width: '120px', display: 'inline-block' }}
                    variant={environment.toLowerCase()}
                  >
                    {environment}
                  </Label>
                </td>
                <td>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <date style={{ width: '80px', marginRight: '10px' }}>
                      {lastSubmitted ? (
                        <Tooltip
                          title={moment(lastSubmitted).format(
                            'MMM Do YYYY, h:mm A'
                          )}
                          placement="top"
                        >
                          <span>
                            {getFromNowDate(lastSubmitted, dueDate)}
                          </span>
                        </Tooltip>
                      ) : (
                        <Tooltip title="Usage data has not been received">
                          <span>No data received</span>
                        </Tooltip>
                      )}
                    </date>
                    {getDaysBetweenDates(lastSubmitted, dueDate) >=
                      MIN_DAYS_TO_SHOW_APPLIANCE_STATUS_WARNING && (
                      <WarningIcon />
                    )}
                  </div>
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
    ) : (
      <p style={{ color: 'rgba(0, 0, 0, 0.57)' }}>
        There are no records at this time.
      </p>
    )}
  </div>
);

ApplianceStatus.propTypes = {
  dueDate: PropTypes.string,
  records: PropTypes.arrayOf(
    PropTypes.shape({
      root_domain_auth: PropTypes.string,
      environment: PropTypes.string,
      last_submitted: PropTypes.string
    })
  )
};

ApplianceStatus.defaultProps = {
  records: [],
  dueDate: moment().toISOString()
};

export default ApplianceStatus;
